var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgDumbell = function SvgDumbell(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M6.33 10.36c-.294-.508-1.008-.646-1.595-.307-.587.34-.825 1.026-.53 1.535l4.254 7.37c.293.508 1.007.646 1.594.307.587-.34.825-1.026.531-1.535zM15.541 5.043c-.293-.509-1.008-.647-1.594-.308-.587.34-.825 1.026-.531 1.535l4.254 7.37c.294.508 1.008.646 1.595.307.587-.34.824-1.026.53-1.535z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M5.24 13.383c-.3-.522-1.02-.67-1.608-.33-.587.338-.818 1.036-.517 1.557l2.182 3.78c.3.521 1.02.67 1.608.33.587-.338.819-1.036.517-1.558zM18.703 5.61c-.301-.521-1.021-.67-1.608-.33-.587.338-.819 1.036-.517 1.558l2.181 3.779c.302.521 1.022.67 1.609.33.587-.338.818-1.036.517-1.558zM16.157 11.017 9.07 15.108l-1.227-2.125 7.085-4.091z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDumbell);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;